export default function ArchivedReportInstanceCommentController(
  $q,
  $rootScope,
  $scope,
  alerts,
  reportsDataService,
  confirmDialog,
  docDataService,
  loaderService,
  orgDataService,
  ssDialogService
) {
  const vm = this;

  // Set Default Values
  vm.canExpand = vm.status !== 'No Report Instance Note Added';
  vm.isExpanded = false;
  vm.canDeleteItem = vm.canDelete;

  // Attach Event Handlers
  vm.handleDelete = _handleDelete;
  vm.handleConfirmDelete = _handleConfirmDelete;
  vm.handleCancelDelete = _handleCancelDelete;

  function _handleDelete($event) {
    ssDialogService.dialogs.reports.deleteReportInstanceCommentDialog = ssDialogService.alert(
      confirmDialog.getOptions($event, {
        dialogTitle: 'Delete Report Instance Note?',
        message: `Are you sure you want to delete Report Instance Note "${vm.reportInstanceComment.text}"?`,
        handleYesClick: _handleConfirmDelete,
        handleNoClick: _handleCancelDelete,
      })
    );

    ssDialogService.show(ssDialogService.dialogs.reports.deleteReportInstanceCommentDialog);
  }

  function _handleConfirmDelete() {
    loaderService.showViewLoader = true;
    return reportsDataService.deleteReportInstanceNote(vm.reportInstanceComment.reportInstanceCommentId).then(() => {
      alerts.success('The Report Instance Note has been deleted successfully.');
      $rootScope.$broadcast('refreshReportInstanceComments',
        { reportInstanceId: vm.reportInstanceComment.reportInstanceId });
      _closeDeleteDialog();
    }).catch(() => {
      alerts.error('Error occurred while deleting the Report Instance Note.');
    }).finally(() => {
      loaderService.showViewLoader = false;
    });
  }

  function _handleCancelDelete() {
    _closeDeleteDialog();
  }

  function _closeDeleteDialog() {
    ssDialogService.hide(ssDialogService.dialogs.reports.deleteReportInstanceCommentDialog);
  }
}

ArchivedReportInstanceCommentController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  'alerts',
  'reportsDataService',
  'confirmDialog',
  'docDataService',
  'loaderService',
  'orgDataService',
  'ssDialogService'
];
